import { useEffect, useState } from "react";
import { Box, Button, Typography, Snackbar } from "@mui/material";
import TermsandConditions from "../userAuth/Login/termsandconditions";
import { useLocation } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [openterms, setOpenterms] = useState(false);
  const location = useLocation();

  // Check if already accepted - strictly "true"
  const isAccepted = localStorage.getItem("cookieConsent") === "true";

  useEffect(() => {
    // If already accepted, don't set up any listeners or timers
    if (isAccepted) {
      if (showBanner) setShowBanner(false);
      return;
    }

    if (location.pathname === "/") {
      const handleScroll = () => {
        if (window.scrollY > 200) {
          setShowBanner(true);
        } else {
          setShowBanner(false);
        }
      };

      window.addEventListener("scroll", handleScroll);

      // Check immediately
      handleScroll();

      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      // Non-home pages: show after 3 seconds
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [location.pathname, isAccepted]);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowBanner(false);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };

  if (isAccepted && !showBanner) return null;

  return (
    <Snackbar
      open={showBanner}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="body2">
          We use cookies to improve your experience. By using our site, you
          agree to our{" "}
          <span style={{ color: "#90caf9", textDecoration: "underline", cursor: "pointer" }} onClick={() => setOpenterms(true)}>
            Privacy Policy
          </span>
          .
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAccept}>
          Accept
        </Button>

        <TermsandConditions
          open={openterms}
          handleCloseTerms={handlecloseterms}
          title={"Privacy Policy"}
          type={"privacy"} // 🔹 Pass 'type' prop (required in API fetch)
        />


      </Box>
    </Snackbar>
  );
};

export default CookieConsent;
